/* * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights
Reserved. * * Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with * the License. A copy of the
License is located at * * http://aws.amazon.com/apache2.0/ * * or in the
"license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR * CONDITIONS OF ANY KIND, either express or
implied. See the License for the specific language governing permissions * and
limitations under the License. */

<template>
  <div class="signin-container">
    <!-- <div>{{ options.header }}</div> -->
    <div class="logo"><img src="@/assets/logo.png" /></div>
    <!-- <amplify-username-field 
        v-bind:usernameAttributes="usernameAttributes" 
        v-on:username-field-changed="usernameFieldChanged">
      </amplify-username-field> -->
    <!-- <div class="header-comment" v-if="isMobilePayment()">
      <span>有料プランをお申し込みの方はログインしてください。</span>
    </div> -->
    <div class="form-input">
      <div class="label">メールアドレス</div>
      <input
        v-model="username"
        type="text"
        autofocus
        v-on:keyup="usernameChanged"
        v-on:input="username = $event.target.value"
      />
    </div>
    <div class="form-input">
      <div class="label">パスワード</div>
      <input v-model="password" type="password" v-on:keyup.enter="signIn" />
    </div>
    <div class="actions" :class="{ disable: sending }">
      <div>
        <div class="submit">
          <span class="login-button" v-on:click="signIn"
            ><span class="arrow-right"></span>ログイン</span
          >
        </div>
        <div class="nav nav-signup">
          <a @click="signUp">または新規登録</a>
        </div>
        <!-- <div v-if="!isMobilePayment()" if class="nav nav-signup">
          <a @click="signUp">または新規登録</a>
        </div> -->
      </div>
      <div class="nav">
        <div>
          <a v-on:click="forgot">パスワードをお忘れの方</a>
        </div>
        <!-- <span v-if="options.isSignUpDisplayed">
          {{ $Amplify.I18n.get("No account? ") }}
          <a v-on:click="signUp">{{ $Amplify.I18n.get("Create account") }}</a>
        </span> -->
      </div>
      <!-- <div v-if="!isMobilePayment()" class="nav">
        <div>
          <a v-on:click="forgot">パスワードをお忘れの方</a>
        </div>
      </div> -->
    </div>
    <div class="error" v-if="error">
      {{ error }}
    </div>
    <!-- <div class="footer-comment" v-if="isMobilePayment()">
      <span>アカウント登録がまだの方はRiceLogアプリから登録してください。<br>パスワードをお忘れの方はRiceLogアプリにて変更してください。</span>
    </div> -->
  </div>
</template>

<script>
// import Auth from '@aws-amplify/auth';
// import AmplifyEventBus from '../../events/AmplifyEventBus';
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapActions } from "vuex";
// import * as AmplifyUI from '@aws-amplify/ui';
// import Vue from 'vue';
// import UsernameField from './UsernameField';

// Vue.component('amplify-username-field', UsernameField);
// import { auth } from '../../assets/data-test-attributes';
// import isMobile from "@/mixins/ismobile";
import ErrorMessage from "@/mixins/errormessages";
import AccountInitializer from "@/mixins/account-initializer";

export default {
  name: "SignIn",
  props: ["signInConfig", "usernameAttributes"],
  mixins: [ErrorMessage, AccountInitializer],
  data() {
    return {
      username: "",
      password: "",
      error: "",
      // amplifyUI: AmplifyUI,
      // auth,
      logger: {},
      signInUsername: "",
      sending: false,
    };
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get("Sign in to your account"),
        username: "",
        isSignUpDisplayed: true,
      };
      return Object.assign(defaults, this.signInConfig || {});
    },
  },
  async mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);

    if (window && window.location && window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      const usernameParam = searchParams
        ? searchParams.get("username")
        : this.username;
      this.username = usernameParam;
      // this.$emit('username-field-changed', {usernameField: 'username', username: usernameParam});
      this.usernameFieldChanged(this.username);
    }
    // // 成功ログ
    // if (this.isMobilePayment()) {
    //   try {
    //     await this.loginlogView();
    //   } catch {
    //     // 処理なし
    //   }
    // }
  },
  methods: {
    ...mapActions(["showAccountID", "checkSystemMaintenance", "loginlogView", "loginlogStart", "loginlogSuccess", "loginlogFail"]),
    signIn: async function () {
      this.sending = true;

      if (!(await this.checkMaintenace())) {
        this.sending = false;
        return;
      }

      // todo: ひとまず変更イベントが発火されないケースがあるので、同様の処理を実行
      this.usernameChanged();

      // // 開始ログ
      // if (this.isMobilePayment()) {
      //   try {
      //     await this.loginlogStart({addr: this.signInUsername, tmp: this.username});
      //   } catch {
      //     // 処理なし
      //   }
      // }

      this.$Amplify.Auth.signIn(this.signInUsername, this.password)
        .then(async (data) => {
          this.sending = false;

          this.logger.info("sign in success");
          
          // // 成功ログ
          // if (this.isMobilePayment()) {
          //   try {
          //     await this.loginlogSuccess({addr: this.signInUsername});
          //   } catch {
          //     // 処理なし
          //   }
          // }

          if (
            data.challengeName === "SMS_MFA" ||
            data.challengeName === "SOFTWARE_TOKEN_MFA"
          ) {
            AmplifyEventBus.$emit("localUser", data);
            return AmplifyEventBus.$emit("authState", "confirmSignIn");
          } else if (data.challengeName === "NEW_PASSWORD_REQUIRED") {
            AmplifyEventBus.$emit("localUser", data);
            return AmplifyEventBus.$emit("authState", "requireNewPassword");
          } else if (data.challengeName === "MFA_SETUP") {
            AmplifyEventBus.$emit("localUser", data);
            return AmplifyEventBus.$emit("authState", "setMfa");
          } else if (
            data.challengeName === "CUSTOM_CHALLENGE" &&
            data.challengeParam &&
            data.challengeParam.trigger === "true"
          ) {
            AmplifyEventBus.$emit("localUser", data);
            return AmplifyEventBus.$emit("authState", "customConfirmSignIn");
          } else {
            const currentAccountID = await this.showAccountID();
            if (!currentAccountID) {
              // アカウントIDがない場合
              // 検証コードの送信が成功しただけでアカウント作成が終わっていないのでここで作成する
              this.sending = true;

              // アカウント初期化
              await this.initializeAccount(this.signInUsername, this.password);

              this.sending = false;

              // 登録完了画面
              return AmplifyEventBus.$emit("authState", "signUpComplete");
            } else {
              // 通常のログイン
              return AmplifyEventBus.$emit("authState", "signedIn");
            }
          }
        })
        .catch(async (e) => {
          this.sending = false;

          if (e.code && e.code === "UserNotConfirmedException") {
            AmplifyEventBus.$emit("localUser", {
              username: this.signInUsername,
            });
            AmplifyEventBus.$emit("waitingConfirmSignUp", {
              password: this.password,
              hasRegisteredEmail: true,
            });
            AmplifyEventBus.$emit("authState", "confirmSignUp");
          } else {
            this.setError(e);
          }

          // // 失敗ログ
          // if (this.isMobilePayment()) {
          //   try {
          //     await this.loginlogFail({addr: this.signInUsername, errcode: e.code});
          //   } catch {
          //     // 処理なし
          //   }
          // }
        });
    },
    forgot: async function () {
      if (!(await this.checkMaintenace())) {
        return;
      }
      AmplifyEventBus.$emit("authState", "forgotPassword");
    },
    signUp: async function () {
      if (!(await this.checkMaintenace())) {
        return;
      }
      AmplifyEventBus.$emit("authState", "signUp");
    },
    setError: function (e) {
      this.error = this.convertSignInErrorMessage(e);
      this.logger.error(this.error);
    },
    usernameChanged() {
      // this.$emit('username-field-changed', {usernameField: 'username', username: this.username});
      this.usernameFieldChanged(this.username);
    },
    usernameFieldChanged: function (username) {
      this.signInUsername = username;
    },

    checkMaintenace: async function () {
      try {
        this.error = "";
        const res = await this.checkSystemMaintenance();
        if (res && res.data && res.data.code === "9") {
          this.error = res.data.message;
          return false;
        }
      } catch (e) {
        console.log(e);
        this.error = "サーバーへの接続に失敗しました。";
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
.signin-container {
  width: 100vw;
  background: #ffffff;
  padding: 3rem;
  color: var(--purple);

  .desktop & {
    width: 552px;
    box-shadow: 0px 0px 20px #00000029;
    border-radius: 25px;
  }

  .logo {
    height: 3rem;
    margin-bottom: 2rem;
    display: flex;
    justify-content: center;

    img {
      object-fit: contain;
    }
  }

  .form-input {
    margin-bottom: 1rem;

    .label {
      margin-bottom: 0.5rem;
    }

    input[type="text"],
    input[type="password"],
    input[type="date"] {
      width: 100%;
      height: 40px;
      border-radius: 20px;
      border: solid 1px var(--purple);
      padding: 0 16px;
      font-size: 16px;
      outline: none;
    }

    input[type="text"]:focus,
    input[type="password"]:focus,
    input[type="date"]:focus {
      background: var(--purple-tertiary);
    }
  }

  .actions {
    margin-top: 3rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    .desktop & {
      margin-top: 4rem;
      justify-content: space-between;
      flex-direction: row-reverse;
    }

    &.disable {
      cursor: none;
      pointer-events: none;
      opacity: 0.5;
    }

    .nav {
      display: flex;
      justify-content: start;
      align-items: center;
      color: #1a82b7;
      cursor: pointer;

      .mobile & {
        margin-top: 3rem;
      }

      a:active {
        opacity: 0.5;
      }
    }

    .submit {
      .login-button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--purple);
        width: 140px;
        height: 44px;
        border-radius: 22px;
        color: #fff;
        padding-right: 18px;
        cursor: pointer;

        .arrow-right {
          display: inline-block;
          width: 26px;
          height: 26px;
          background-image: url("~@/assets/icons/ic_arrow_login.svg");
          background-size: 26px 26px;
          transform: rotate(180deg);
          margin-left: 10px;
        }

        &:active {
          opacity: 0.7;
        }
      }
    }

    .nav-signup {
      padding-top: 1rem;
      justify-content: center;
    }
  }

  .error {
    .mobile & {
      padding-top: 1rem;
    }
  }
  .signin-header {
    padding-bottom: 30px;
    h2 {
      text-align: center;
      color: var(--purple);
      font-weight: 400;
    }
  }
  .header-comment {
    font-size: 1rem;
    padding-bottom: 1rem;
  }
  .footer-comment {
    font-size: 1rem;
    padding-top: 1rem;
  }
}
</style>
